<div class="content">

  <div class="form-groups-column buffer-bottom">
    <div class="form-group">
      <label>Firstname</label>
      <input type="text" class="form-control" [(ngModel)]="firstname" [disabled]="isEdit"/>
    </div>

    <div class="form-group">
      <label>Surname</label>
      <input type="text" class="form-control" [(ngModel)]="surname" [disabled]="isEdit"/>
    </div>
    
    <div class="form-group">
      <label>Credentials</label>
      <input type="text" class="form-control" [(ngModel)]="credentials" />
    </div>


    <div class="form-group">
      <label>PIN</label>
      <input type="password" name="password1" class="form-control" [(ngModel)]="password" placeholder="unchanged" autocomplete="off" />
    </div>

    <div class="form-group">
      <label>Confirm PIN</label>
      <input type="password" name="password2" class="form-control" [(ngModel)]="password2" placeholder="unchanged" autocomplete="off" />
    </div>


  </div>


  <div class="action-buttons">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <div class="spacer" *ngIf="id != null"></div>
    <button *ngIf="id != null" class="btn btn-danger btn-save" (click)="delete()">Deactivate</button>
    <div class="spacer"></div>
    <button class="btn btn-back" (click)="back()">Back</button>
  </div>
</div>
